import type { ReactNode } from 'react';

interface EmptyBlockProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyBlock({ title, description, action }: EmptyBlockProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <h3 className="text-base font-semibold text-muted-foreground">{title}</h3>
      {description && (
        <p className="text-sm text-muted-foreground/70 mt-1 max-w-xs">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
